import { render, staticRenderFns } from "./VipCate.vue?vue&type=template&id=31c69acc&scoped=true&"
import script from "./VipCate.vue?vue&type=script&lang=js&"
export * from "./VipCate.vue?vue&type=script&lang=js&"
import style0 from "./VipCate.vue?vue&type=style&index=0&id=31c69acc&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31c69acc",
  null
  
)

export default component.exports